/* eslint-disable max-lines */
import { InitialConfigType, LexicalComposer } from '@lexical/react/LexicalComposer';
import { readNotification } from 'actions/notifications';
import LinkLookup from 'components/LinkLookup';
import { COMMENT_ICON } from 'constants/envelopeIcons';
import moment from 'moment';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Notification } from 'types';
import LoadHtmlPlugin from 'utils/lexical/LoadHtmlPlugin';

type ComponentProps = {
  notification: Notification;
  index: number;
};

const NotificationItem: React.FC<ComponentProps> = ({ notification, index }) => {
  const dispatch = useDispatch();
  const [textContent, setTextContent] = useState('');
  const [hover, setHover] = useState(false);

  const {
    created_by: createdBy,
    created_at: createdAt,
    envelope_action: action,
    payload,
    read,
  } = notification;

  const handleReadNotification = (): void => {
    dispatch(readNotification({ ...notification, read: true }));
  };

  const commentConfig: InitialConfigType = {
    namespace: 'comment-editor-row',
    editable: false,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (error: any): void => {
      throw error;
    },
  };

  return (
    <div
      onMouseEnter={(): void => setHover(true)}
      onMouseLeave={(): void => setHover(false)}
      className={`shadow-filte-hover w-full p-2 flex flex-row gap-2 overflow-visible border-b border-litlingo-gray-1 cursor-pointer ${
        index === 0 ? 'rounded-t' : ''
      } ${read ? 'bg-litlingo-gray-0.5' : 'bg-white'}`}
    >
      <div
        className={`h-8 min-w-8 flex items-center justify-center rounded-full ${
          read ? 'bg-litlingo-gray-3' : 'bg-litlingo-primary-80'
        }`}
      >
        <div className="w-5">{COMMENT_ICON()}</div>
      </div>
      <div className="flex flex-col gap-1 flex-1 overflow-hidden">
        <p className="text-small-2">
          <b>{createdBy?.name}</b> tagged you
        </p>
        <span className="truncate text-small">{textContent}</span>
        <LexicalComposer initialConfig={commentConfig}>
          <LoadHtmlPlugin
            edited={false}
            insertQuotes
            content={action?.value || ''}
            setTextContent={setTextContent}
          />
        </LexicalComposer>
        <div className="flex flex-row justify-between text-small-2">
          <span className="italic">{moment(createdAt).format('DD MMM yyyy, hh:mma')}</span>
          {hover && (
            <LinkLookup
              routeName="envelope-detail"
              routeParams={{ envelopeId: payload.communication_envelope_uuid }}
              onClick={(): void => {
                handleReadNotification();
              }}
              className="text-litlingo-primary underline"
            >
              View message
            </LinkLookup>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationItem;
